export default __webpack_public_path__ + "static/media/erp-para-empresas-de-confeccion.dd508f76.png";